import r from "react";
import { PaymentStages as a } from "./index232.mjs";
const g = ({
  paymentConditions: c
}) => {
  const o = (n) => {
    const { percent: t, stage: _, days: e } = n;
    switch (_) {
      case a.AT_BOOKING:
        return I18n.t("booking_engine.payment_percentages.at_booking", {
          percent: t.toString()
        });
      case a.BEFORE_CHECK_IN:
        return e === 0 ? I18n.t("booking_engine.payment_percentages.on_check_in", {
          percent: t.toString()
        }) : e ? I18n.t("booking_engine.payment_percentages.before_check_in", {
          percent: t.toString(),
          days: e.toString()
        }) : "";
      case a.ON_CHECK_IN:
        return I18n.t("booking_engine.payment_percentages.on_check_in", {
          percent: t.toString()
        });
      case a.BEFORE_CHECK_OUT:
        return I18n.t("booking_engine.payment_percentages.before_check_out", {
          percent: t.toString(),
          days: (e == null ? void 0 : e.toString()) || "1"
        });
      default:
        return "";
    }
  };
  return /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement("div", null, I18n.t("booking_engine.payment_percentages")), /* @__PURE__ */ r.createElement("ul", null, c.map((n) => /* @__PURE__ */ r.createElement("li", { key: `${n.stage}-${n.percent}` }, o(n)))));
}, s = g;
export {
  s as default
};
